<template>
  <div class="panel_shouyin">
    <div class="titleLine">
      <el-row>
        <el-col :span="7">
          商品套餐：{{ curCardId }}
          <el-select v-model="groupId" @change="changeGroupId" placeholder="请选择商品套餐" size="mini" style="width: 200px">
            <el-option v-for="(item, index) in groupList" :key="index" :label="item.title"
              :value="item.groupId"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          录入条码：
          <el-input size="mini" style="width: 150px" v-model="scanningCodeInput"
            @keyup.enter.native="clickScanningCodeInput" placeholder="请录入条码">
          </el-input>
        </el-col>
        <el-col :span="3">
          <!-- 其他： -->
          <el-button size="mini" @click="dialogAddGoods_state = true">其他</el-button>
        </el-col>
        <el-col :span="2" :offset="6">
          <!-- 礼品卡： -->
          <el-button size="mini" @click="$store.commit('mendian/set_curBusiness', '购买礼品卡')">礼品卡</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="tableBox" ref="tableBox">
      <el-table :data="tableData" height="100%" style="width: 100%" size="mini" default-expand-all>
        <el-table-column type="expand" width="30">
          <template slot-scope="props">
            <div v-if="!$public.isNull(props.row.giftList)">
              <el-table :data="props.row.giftList" style="width: 100%; margin-bottom: 20px" size="mini"
                row-key="tableKey" :empty-text="'没有录入赠品'">
                <el-table-column label="赠品名称" min-width="150">
                  <template slot-scope="giftItem">
                    {{ giftItem.row.goodsName }}
                  </template>
                </el-table-column>
                <el-table-column label="赠品规格" min-width="150">
                  <template slot-scope="giftItem">
                    {{ giftItem.row.skuValue }}
                  </template>
                </el-table-column>
                <el-table-column label="赠品数量" min-width="150">
                  <template slot-scope="giftItem">
                    {{ giftItem.row.num }}
                    <el-tooltip style="margin: 4px" effect="dark" placement="top">
                      <div slot="content">
                        <span v-for="tm in giftItem.row.goodsList" :key="tm.customCode">{{ tm.customCode }}
                        </span>
                      </div>
                      <span style="cursor: pointer">条码</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.goodsName }}
            <span v-if="scope.row.activityType === 5" style="color: red">(抵)</span>
          </template>
        </el-table-column>
        <el-table-column prop="customCode" label="宠物" min-width="100">
          <template slot-scope="scope">
            <el-select v-model="scope.row.petId" placeholder="请选择" size="mini">
              <el-option popper-class="select" v-for="item in userInfo.pets_info" :key="item._id"
                :label="item.nick_name" :value="item._id"></el-option>
            </el-select>
            <!-- {{scope.row.petName}} -->
          </template>
        </el-table-column>
        <el-table-column label="规格" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.skuValue }}
          </template>
        </el-table-column>
        <el-table-column prop="originalPrice" label="标准价/会员价" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.originalPrice }}/{{
          scope.row.vipPrice == 0
            ? scope.row.originalPrice
            : scope.row.vipPrice
        }}
          </template>
        </el-table-column>

        <el-table-column label="活动" width="130">
          <template slot="header">
            活动
            <img style="width: 18px; vertical-align: sub; cursor: pointer" @click="refreshActivityList"
              src="../../../../assets/img/refresh.png" />
          </template>
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.tableKey==='tableKey605a8b2c652fbf8339c22620'&&scope.row.goodsType===2"> -->
            <span>
              <el-select v-model="scope.row.activityId" :disabled="!$public.isNull(curDiscountCard) || scope.row.disabled
          " @change="changeActivityId(scope.row)" placeholder="请选择" size="mini" style="width: 120px" clearable>
                <el-option v-for="item in scope.row.activityList" :key="item._id" :label="item.name" :value="item._id"
                  :disabled="!$public.calcActivity(
          item,
          $public.cheng(scope.row.originalPrice, scope.row.num),
          scope.row.num
        ).state
          "></el-option>
              </el-select>
            </span>
          </template>
        </el-table-column>
        <!-- ------------- 优惠券--------------------------------------------------------------------------- -->
        <el-table-column label="优惠券" min-width="110">
          <template slot-scope="scope">
            <el-select :disabled="scope.row.disabled" v-model="scope.row.couponId" @clear="clearyouhui(scope.row)"
              @change="changecoupon(scope.row)" clearable placeholder="请选择" size="mini">
              <el-option popper-class="select" v-for="item in scope.row.couponList" :key="item._no"
                :label="item.coupon_name + '(' + item._no + ')'" :value="item._no"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="优惠价" width="100">
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.tableKey==='tableKey605a8b2c652fbf8339c22620'&&scope.row.goodsType===2"> -->
            <span
              v-if="scope.row.tableKey === 'tableKey605a8b2c652fbf8339c22620' && scope.row.goodsType === 2 && scope.row.vipPrice == 0">
              <el-input v-model="scope.row.price" @input="changeNum(scope.row)" size="mini"></el-input>
            </span>
            <span v-else>
              {{ scope.row.price }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="数量" min-width="85">
          <template slot-scope="scope">
            <el-input-number :disabled="scope.row.goodsType === 2" v-model="scope.row.num" :controls="false"
              controls-position="right" :min="1" :max="1000" style="width:80px" @change="handleNumChange(scope)"
              size="small" />
          </template>
        </el-table-column>
        <el-table-column label="总金额" min-width="60">
          <template slot-scope="scope">
            {{ $public.cheng(scope.row.price, scope.row.num) }}
          </template>
        </el-table-column>
        <el-table-column label="单位" min-width="45">
          <template slot-scope="scope">
            {{ scope.row.unit }}
          </template>
        </el-table-column>
        <el-table-column label="销售人员" min-width="110">
          <template slot-scope="scope">
            <el-select :disabled="scope.row.staffdisabled" v-model="scope.row.staff"
              @change="changeStaff(scope.$index, scope.row)" multiple filterable placeholder="请选择" size="mini">
              <el-option popper-class="select" v-for="item in staffList" :key="item._id"
                :label="item.basic_info.nick_name" :value="item._id + ',' + item.basic_info.nick_name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="50">
          <template slot-scope="scope">
            <span>
              <span>
                <img class="btn_operate" @click="del_goods(scope.row, scope.$index)"
                  src="../../../../assets/img/shanchu.png" />
              </span>
              <span v-if="!$public.isNull(scope.row.groupObj) &&
          !$public.isNull(scope.row.groupObj.groupId)
          " @click="changeGroup(scope.row)">
                编辑
              </span>
              <span v-if="!$public.isNull(scope.row.activityItem) &&
          scope.row.activityItem.consume_type === 2
          " @click="changeGiftList(scope.row)">
                赠品
              </span>
            </span>
          </template>
        </el-table-column>
        <span slot="empty">
          <img src="../../../../assets/img/kong.png" style="width: 340px; padding-top: 0px" />
          <div style="font-size: 14px; color: #333; margin: 0px">
            请用扫码枪扫描商品码
          </div>
        </span>
      </el-table>
    </div>
    <el-dialog :visible.sync="dialogWay_state" :close-on-click-modal="false" :show-close="false" :width="'300px'">
      <div slot="title">
        <span>售卖方式</span>
      </div>
      <div style="
          font-size: 16px;
          color: red;
          margin-bottom: 25px;
          text-align: center;
        "></div>
      <el-radio-group v-model="dialogWay_curId" style="text-align: center; width: 100%">
        <el-radio :label="item.packing_way_id" v-for="(item, index) in dialogWay_obj.saleWays" :key="index">
          {{ item.packing_way_name }}
        </el-radio>
      </el-radio-group>
      <div slot="footer">
        <el-row style="text-align: center">
          <el-button type="cancel" @click="cancel_dialogWay">取消</el-button>
          <el-button type="success" @click="submit_dialogWay">确定</el-button>
        </el-row>
      </div>
    </el-dialog>
    <!-- 套餐 -->
    <div v-if="dialogAddGroup_state">
      <dialogAddGroup :shopId="curShopId" :groupItem="groupItem" @submit="submit_dialogAddGroup"></dialogAddGroup>
    </div>
    <!-- 补差价和洗澡 -->
    <div v-if="dialogAddGoods_state">
      <dialogAddShop :addShopState="dialogAddGoods_state" :shopId="curShopId" :tree="[
          {
            id: '601d11cda93f55b5cf3ae2d1',
            children: [
              { id: '605a8b2c652fbf8339c22620' },
              { id: '605996155011826976dd8114' },
            ],
          }
        ]" @submit="submit_dialogAddGoods" @closeOn="dialogAddGoods_state = false"></dialogAddShop>
    </div>
    <!-- 赠品 -->
    <div v-if="drawerGift_state">
      <setGift :giveGoods="giveGoods" @submit="submit_drawerGift"></setGift>
    </div>
    <div v-if="dialogUnPayOrderList_state">
      <unPayOrderList @submit="dialogUnPayOrderList_submit"></unPayOrderList>
    </div>
  </div>
</template>
<script>
import { getetMemberCanUseCoupon, getActivityPrice } from "@/api/newCoupon.js";
// import joinActivity from "../../../../components/joinActivity.vue"
import dialogAddShop from "../../../../components/dialog_addShop.vue";
import dialogAddGroup from "../drawer/saleAddGroup.vue";
import setGift from "../../../../components/drawer/setGift.vue";
import unPayOrderList from "../drawer/unPayOrderList.vue";
import delSale from "../../../../util/delSale.js";
export default {
  components: { dialogAddShop, dialogAddGroup, setGift, unPayOrderList },
  data() {
    return {
      o: null,
      curIndex: -1,
      tableData: [], // 全等于saleList
      staffList: [],
      // 选择商品套餐
      groupId: "",
      groupItem: {},
      groupList: [],
      // 补差价和洗澡
      dialogAddGoods_state: false,
      // 录入商品套餐
      curGroupInfo: {},
      curGroupTable: [],
      dialogAddGroup_state: false,
      // 扫码
      scanningCodeInput: "",
      //待支付订单
      dialogUnPayOrderList_state: false,
      // 售卖方式
      dialogWay_state: false,
      dialogWay_obj: {},
      dialogWay_curId: "",
      // 赠品
      drawerGift_state: false,
      giveGoods: {},
      couponList: [], //优惠券列表
      couponId: "",
      couponName: "",
      couponIdList: [],
      isMember: false,
      isDisabled: false
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
          pet_count: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    curShopId() {
      return this.$store.state.shopId;
    },
    curCardId() {
      return this.$store.state.mendian.curCardId;
    },
    saleList() {
      return this.$store.state.mendian.saleList;
    },
    unPayOrderList() {
      return this.$store.state.mendian.unPayOrderList;
    },
    curDiscountCard() {
      return this.$store.state.mendian.curDiscountCard;
    },
    isvip() {
      return this.$store.state.mendian.isvip;
    },
  },
  watch: {
    isvip() {
      this.getTotal();
    },
    userInfo() {
      this.isMember = this.userInfo.club_card.is_valid;
    },
    saleList(n) {
      if (n.length === 0) {
        this.o.init([]);
      } else {
        n.forEach((element) => {
          if (element.goodsType == 12) {
            this.isMember == true;
          } else {
            this.isMember = this.userInfo.club_card.is_valid;
          }
          // 判断是否有会员卡
        });
        this.o.init(n);
      }
      this.tableData = [];
      n.forEach((element) => {
        this.tableData.push(element);
      });
    },
  },
  mounted() {
    this.init();

    this.isMember = this.userInfo.club_card.is_valid;
    this.$store.dispatch("mendian/get_unPayOrderList");
    let params = {
      applytype: "",
      keyword: "",
      categoryId: "604323834335a2f958dc7412",
      shopId: "",
      pageIndex: 1,
      pageSize: 100,
    };
    this.$http
      .post(process.env.VUE_APP_Url2 + "api/product/group/goods/list", params)
      .then((res) => {
        if (res.code == 0) {
          this.groupList = res.data.data;
        }
      });
  },
  methods: {
    handleNumChange(scope) {
      console.log(scope.row, '数量库存');
      let wayItem = scope.row.sale_way_packing_exchange.filter((item) => {
        return item['salePackingWayId'] == scope.row.unitId
      })[0];
      let exchangeCount = wayItem.exchangeCount
      if (exchangeCount * scope.row.num > scope.row.stock) {
        this.$message({
          message: `库存不足！！！,本店还有库存${scope.row.stock}`,
          type: "error",
        });
        this.tableData[scope.$index].num = 1;
        this.$nextTick(() => {
          this.tableData[scope.$index].num = -1
          setTimeout(() => {
            this.tableData[scope.$index].num = 1
          }, 50);
        })

        this.getTotal();
      } else if (exchangeCount * scope.row.num <= scope.row.stock) {
        console.log('库存充足');
        let num = 0;
        num += scope.row.num;
        this.$set(this.tableData[scope.$index], ['num'], num);
        this.getTotal();
      }

    },
    clearyouhui(row) {
      const selectDiscount = this.$store.state.mendian.selectdiscount;
      selectDiscount.forEach((item, index) => {
        if (item == row.ceshi) {
          selectDiscount.splice(index, 1);
          this.$store.commit("mendian/set_selectdiscount", selectDiscount);
        }
      });
    },
    init() {
      this.o = new delSale();
      this.o.init(this.saleList);
      this.tableData = this.o.arr;

      this.$store.commit("mendian/set_saleList", this.o.arr);

      this.getStaffList();
    },
    //////////////////////////  挂号和洗澡
    changeNum(row) {
      row.price = this.$public.replaceGoodsDosage(row.price);
      row.originalPrice = row.price;
      this.getTotal();
    },
    submit_dialogAddGoods({ goodsItem, skuItem, wayItem, goodsType }) {
      if (this.$public.isNull(this.userInfo._id)) {
        this.$message({
          message: "请选择顾客",
          type: "error",
        });
        return;
      }
      this.dialogAddGoods_state = false;
      let goods = {
        activityId: "",
        activityItem: {},
        activityList: [],
        couponList: [],
        customCode: "",
        totaTimes: 1, // 总次数
        useTimes: 0, // 已使用次数
        onlyTimes: 1,
        tableKey: "tableKey" + goodsItem.category_list[1]._id, //tableKey605a8b2c652fbf8339c22620 差价 tableKey605996155011826976dd8114 娱乐
        petId: this.curPetInfo._id ? this.curPetInfo._id : "",
        petName: this.curPetInfo._id ? this.curPetInfo.nick_name : "",
        brand: "",
        categoryId: goodsItem.category_info._id,
        categoryName: goodsItem.category_info.name,
        huotiType: 0,
        goodsId: goodsItem.serviceId,
        goodsName: goodsItem.title,
        goodsType: 2, //  0:商品 1:药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.卡 7.耗材 8.组合套餐
        goodsUsage: "", // 用法
        goodsDosage: "", // 用量
        originalPrice: skuItem.price, // 原价
        vipPrice: skuItem.mprice,
        price: skuItem.price, // 现价
        costPrice: 0,
        num: 1, // 数量
        skus: skuItem.service_objectId,
        skuValue: skuItem.service_objectName,
        unitId: "",
        unit: "",
        totalMoney: 0,
        staff: [], // 销售人员
        validityStopDate: "", // 有效期
        goodsList: [],
        giftList: [],
        checkGoods: [],
        saleWays: "",
        buyBack: 0,
      };
      this.$store.state.mendian.userController.map((controller) => {
        if (controller.invitationType === 1 && controller.userId.length > 0) {
          goods.staff = [controller.userId + "," + controller.userName];
        }
      });
      this.tableData.push(goods);
      this.getActivityListByArr(this.tableData, this.tableData.length - 1);
      this.getCouponParam(this.tableData, this.tableData.length - 1);
      // if(goods.tableKey==='tableKey605a8b2c652fbf8339c22620'){  // 补差价
      // 	this.tableData.push(goods)
      // 	this.$store.commit('mendian/set_saleList',this.tableData)
      // 	this.getTotal();
      // }else if(goods.tableKey==='tableKey605996155011826976dd8114'){  // 娱乐
      // 	this.tableData.push(goods)
      // 	this.getActivityListByArr(this.tableData,this.tableData.length-1)
      // }else if(goods.tableKey==='tableKey605a8b2c652fbf8339c220'){  // 其它
      // 	this.tableData.push(goods)
      // 	this.getActivityListByArr(this.tableData,this.tableData.length-1)
      // }
    },
    ////////////////////////////////////////////////// 售卖商品套餐
    changeGroupId() {
      if (this.$public.isNull(this.userInfo._id)) {
        this.$message({
          message: "请选择顾客",
          type: "error",
        });
        this.groupId = "";
        return;
      }
      this.curIndex = -1;
      this.groupItem = this.$public.getMatchingItem(
        this.groupList,
        "groupId",
        this.groupId
      );
      this.groupId = "";
      if (this.$public.isNull(this.groupItem.group_items)) {
        // 套餐内只有虚拟商品
        this.o.addGroup(this.groupItem, this.tableData, this.curIndex);
        this.getActivityListByArr(
          this.o.arr,
          this.o.getOneIndex(this.o.curItem)
        );
        this.getCouponParam(this.o.arr, this.o.getOneIndex(this.o.curItem));
      } else {
        this.dialogAddGroup_state = true;
      }
    },
    submit_dialogAddGroup(obj) {
      this.dialogAddGroup_state = false;
      if (obj.type === "success") {
        let staff = [];
        this.$store.state.mendian.userController.map((controller) => {
          if (controller.invitationType === 1 && controller.userId.length > 0) {
            staff = [controller.userId + "," + controller.userName];
          }
        });
        this.o.addGroup(this.groupItem, obj.data, this.curIndex, staff);
        this.getActivityListByArr(
          this.o.arr,
          this.o.getOneIndex(this.o.curItem)
        );
        this.getCouponParam(this.o.arr, this.o.getOneIndex(this.o.curItem));
      } else {
        console.log("group close");
      }
    },
    changeGroup(row) {
      this.curIndex = row.index;
      let groupItem = JSON.parse(JSON.stringify(row.groupObj));
      groupItem.groupTableData = row.groupTableData;
      this.groupItem = groupItem;
      this.dialogAddGroup_state = true;
    },
    //////////////////////////////////////////////////////// 待支付订单
    dialogUnPayOrderList_submit(obj) {
      this.dialogUnPayOrderList_state = false;
    },
    ////////////////////////////////////////////////////////// 商品
    clickScanningCodeInput() {
      if (this.$public.isNull(this.userInfo._id)) {
        this.$message({
          message: "请选择顾客",
          type: "error",
        });
      } else {
        this.getScanData(this.scanningCodeInput);
      }
      this.$nextTick(() => {
        this.scanningCodeInput = "";
        this.curIndex = -1;
      });
    },
    getScanData(code) {
      let obj = {
        code: code,
        shopid: this.curShopId
      }
      this.o.searchGoods({ obj }).then((res) => {
        // 602f1e88c904d9db7ccf3bec 医疗类一级分类id
        if (res.category_list[0]._id === "602f1e88c904d9db7ccf3bec") {
          this.$message({
            message: "该商品属于医疗用品，不可在门店业务模块售卖！",
            type: "error",
          });
          return;
        }
        if (res.saleWays == null || res.saleWays == undefined) {
          res.saleWays = [];
        }
        if (res.saleWays.length > 1) {
          // 多售卖方式
          this.dialogWay_curId = "";
          this.dialogWay_obj = {
            saleWays: res.saleWays,
          };
          this.dialogWay_state = true;
        } else {
          console.log(res, 'res商品');
          let wayItem = res.saleWays;
          this.o.curItem.unitId = wayItem[0].packing_way_id;
          this.o.curItem.unit = wayItem[0].packing_way_name;
          this.o.curItem.originalPrice = res.is_discount ? res.discount_price : wayItem[0].pprice;
          this.o.curItem.vipPrice = res.is_discount ? res.discount_price : wayItem[0].mprice;
          this.o.curItem.price = res.is_discount ? res.discount_price : wayItem[0].pprice;
          this.o.curItem.totalMoney = res.is_discount ? res.discount_price : wayItem[0].pprice;
          console.log(this.o.curItem, 'this.o.curItem');
          let addState = this.o.addGoods();
          if (addState === true) {
            console.log("添加成功");
            this.getActivityListByArr(
              this.o.arr,
              this.o.getOneIndex(this.o.curItem)
            );
            this.getCouponParam(this.o.arr, this.o.getOneIndex(this.o.curItem));
          }

        }
      });
    },

    del_goods(row, index) {
      if (row.twoIndex === undefined) {
        // 删 一级
        this.$confirm("确定要删除?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.o.del([index, -1]);
          this.o.arr.forEach(item => item.price = item.originalPrice)
          this.$store.commit("mendian/set_saleList", this.o.arr);

          this.getTotal();
        });
      } else {
        // 删 二级
        this.$confirm("确定要删除?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.o.del([row.oneIndex, row.twoIndex], true);
          this.$store.commit("mendian/set_saleList", this.o.arr);
          this.getTotal();

          this.getActivityListByArr(
            this.o.arr,
            this.o.getOneIndex(this.o.curItem)
          );
          this.getCouponParam(this.o.arr, this.o.getOneIndex(this.o.curItem));
        });
      }
    },
    ///////////////////////////////////////////// 销售单位
    cancel_dialogWay() {
      this.dialogWay_state = false;
    },
    submit_dialogWay() {
      this.dialogWay_state = false;
      let wayItem = this.$public.getMatchingItem(
        this.dialogWay_obj.saleWays,
        "packing_way_id",
        this.dialogWay_curId
      );
      this.o.curItem.unitId = wayItem.packing_way_id;
      this.o.curItem.unit = wayItem.packing_way_name;
      this.o.curItem.originalPrice = wayItem.pprice;
      this.o.curItem.vipPrice = wayItem.mprice;
      this.o.curItem.price = wayItem.pprice;
      this.o.curItem.totalMoney = wayItem.pprice;
      let addState = this.o.addGoods();
      console.log(addState, 'addState');
      if (addState === true) {
        console.log("添加成功");
        this.getActivityListByArr(this.o.arr, this.o.getOneIndex(this.o.curItem));
        this.getCouponParam(this.o.arr, this.o.getOneIndex(this.o.curItem));
      }


    },
    /////////////////////////////////////////  赠品
    changeGiftList(row) {
      let calcResult = this.$public.calcActivity(
        row.activityItem,
        this.$public.cheng(row.originalPrice, row.num),
        row.num
      );
      row.price = calcResult.newPrice;
      this.curIndex = row.index;
      this.giveGoods = calcResult.gift;
      this.giveGoods.giftTableData = row.giftList;
      this.drawerGift_state = true;
    },
    submit_drawerGift({ giftTableData }) {
      this.drawerGift_state = false;
      this.o.arr[this.curIndex].giftList = giftTableData;
    },
    //////////////////////////////////////////////////// 活动
    refreshActivityList() {
      if (this.tableData.length > 0) {
        this.getActivityListByArr(this.o.arr, -1);
        this.getCouponParam(this.o.arr, -1);
      }
    },
    changeActivityId(row) {
      if (this.$public.isNull(row.activityId)) {
        if (this.isMember) {
          row.price = row.vipPrice;
        } else {
          row.price = row.originalPrice;
        }

        row.activityItem = {};
        row.giftList = [];
        this.o.init(this.tableData);
      } else {
        row.couponId = "";
        row.activityItem = {};
        row.giftList = [];
        let activityItem = this.$public.getMatchingItem(
          row.activityList,
          "_id",
          row.activityId
        );
        let calcResult = this.$public.calcActivity(
          activityItem,
          this.$public.cheng(row.originalPrice, row.num),
          row.num
        );
        row.price = this.$public.chu(calcResult.newPrice, row.num);
        row.activityItem = activityItem;
        if (!this.$public.isNull(calcResult.gift.give_list)) {
          this.curIndex = row.index;
          this.giveGoods = calcResult.gift;
          this.drawerGift_state = true;
        }
      }

      this.$store.commit("mendian/set_saleList", this.tableData);
      this.getTotal();
    },
    getActivityListByArr(arr, index) {
      this.$util.getActivityOfProduct(this.userInfo, arr).then((res) => {
        for (let i = 0; i < arr.length; i++) {
          if (
            arr[i].goodsName.includes("特价") ||
            arr[i].goodsName.includes("五折价") ||
            arr[i].goodsName.includes("两折价") ||
            arr[i].goodsName.includes("八折价")
          ) {
            arr[i].disabled = true;
          } else {
            arr[i].disabled = false;
          }
          if (arr[i].goodsName.includes("两折价")) {
            arr[i].staff = ["62ee0f7ac93f541cc51a306d,系统小花"];
            arr[i].staffdisabled = true;
          } else {
            arr[i].staffdisabled = false;
          }

          arr[i].activityList = res[i].list;
          if (index === i || index === -1) {
            if (
              (arr[i].activityId != null && arr[i].activityId !== "") ||
              arr[i].couponId == "" ||
              arr[i].couponId == null
            ) {
              if (
                index >= 0 &&
                !this.$public.isNull(res[index].list) &&
                res[index].list[0].auto_matching > 0
              ) {
                if (
                  this.$public.isNull(
                    this.curDiscountCard && this.curDiscountCard._no
                  ) &&
                  !arr[i].goodsName.includes("五折价") &&
                  !arr[i].goodsName.includes("两折价") &&
                  !arr[i].goodsName.includes("八折价")
                ) {
                  arr[index].activityId = res[index].list[0]._id;
                  arr[index].activityItem = res[index].list[0];
                  let calcResult = this.$public.calcActivity(
                    arr[index].activityItem,
                    this.$public.cheng(
                      arr[index].originalPrice,
                      arr[index].num
                    ),
                    arr[index].num
                  );

                  arr[index].price = this.$public.chu(
                    calcResult.newPrice,
                    arr[index].num
                  );
                  if (!this.$public.isNull(calcResult.gift.give_list)) {
                    this.curIndex = arr[index].index;
                    this.giveGoods = calcResult.gift;
                    this.drawerGift_state = true;
                  }
                }
              }
            }
          }
        }
        this.$store.commit("mendian/set_saleList", arr);
        this.getTotal();
      });
    },
    //////////////////////////////////////////////////////// 销售人员
    changeStaff(index, row) {
      console.log(index, row,this.tableData,'??bbbppoo');
      let tableData = this.tableData;
      if (index == 0) {
        for (let i = 0; i < tableData.length; i++) {
          console.log(tableData[i].staff,'?????????????________________');
          if (tableData[i].staff==null||tableData[i].staff.length==0) {
            tableData[i].staff = tableData[0].staff;
          }
        }
      }
      // for(let i=0;i<tableData.length;i++){
      // 	let salesMans = []
      // 	for(let b=0;b<tableData[i].staff.length;b++){
      // 		for(let c=0;c<this.staffList.length;c++){
      // 			if(this.staffList[c]._id==tableData[i].staff[b]){
      // 				let staff = {"userId": this.staffList[c]._id,"userName": this.staffList[c].basic_info.nick_name}
      // 				salesMans.push(staff);
      // 			}
      // 		}
      // 	}
      // 	tableData[i].salesMans = salesMans;
      // }
      this.o.init(tableData);
    },
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      this.$http.get("/api/Staff/List", params).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data.data;
        }
      });
    },
    /////////////////////////优惠券
    changecoupon(row) {
      const selectDiscount = this.$store.state.mendian.selectdiscount;

      let flag = false;
      selectDiscount.forEach((item) => {
        if (item == row.couponId) {
          this.$message({
            message: "不能选择重复的券！",
            type: "error",
          });
          flag = true;
        }
      });
      if (!flag) {
        if (row.ce2) {
          const index = selectDiscount.indexOf(row.ce2);
          if (index != -1) {
            selectDiscount.splice(index, 1);
            this.$store.commit("mendian/set_selectdiscount", selectDiscount);
          }
        }
        this.getCalcGoodsPrice(row);
        row.activityType = 5;
        row.goodsCouponId = row.couponId;
        row.goodsCouponName = this.$public.getMatchingItem(
          row.couponList,
          "_no",
          row.couponId
        ).coupon_name;
        row.activityId = "";
        row.activityName = "";
        this.$set(this.tableData, row);

        this.$store.commit("mendian/set_saleList", this.tableData);
        this.getTotal();
      } else {
        row.couponId = "";
      }

      if (row.couponId) {
        row.ce2 = row.couponId;
        row.ceshi = JSON.parse(JSON.stringify(row.couponId));
        selectDiscount.push(row.couponId);
        this.$store.commit("mendian/set_selectdiscount", selectDiscount);
      }
      this.getCalcGoodsPrice(row);
    },
    // 获取优惠金额
    getCalcGoodsPrice(row) {
      let params = {
        memberId: this.userInfo._id,
        originalPrice: row.originalPrice,
        num: row.num,
        couponNo: row.couponId,
      };
      getActivityPrice(params).then((res) => {
        if (res.code == 0) {
          if (Number(res.data) < 0) {
            res.data = 0;
          }
          row.price = Number(res.data);
          this.$set(this.tableData, row);
          this.$store.commit("mendian/set_saleList", this.tableData);
          this.getTotal();
        }
      });
    },

    // 获取用户可用优惠券列表
    getCouponParam(arr, index) {
      let params = {
        member_id: this.userInfo._id, //顾客id
        order_type_id: 0, //订单类型
        money: arr[index].originalPrice, //订单价格
        category_id: arr[index].categoryId, //分类id
        goods_id: arr[index].goodsId, //商品id
        sku_id: arr[index].skus,
        packing_way_id: arr[index].unitId, //包装方式id
        use_scene: 2, //使用场景 0 全部 1线上 2线下
      };

      getetMemberCanUseCoupon(params).then((res) => {
        if (res.code == 0) {
          arr[index].couponList = res.data;
        }
      });
      if (arr[index].couponId !== "" && arr[index].couponId != null) {
        this.getCalcGoodsPrice(arr[index]);
      }
    },
    //////////// 计算总计
    getTotal() {
      let arr = this.saleList;
      let total = {
        total: 0,
        activity: 0,
        viptotal: 0,
        showVip: false,
      };
      let vipIndex = arr.findIndex((item) => item.goodsType == 12);
      this.$store.commit("mendian/set_vipIndex", vipIndex);
      for (let i = 0; i < arr.length; i++) {
        let selectdiscount = this.$store.state.mendian.selectdiscount;
        // 判断是否使用了活动  如果没有使用活动并且没有使用单个商品的优惠券并且是会员或添加的有会员月卡就把price改为vipprice
        if (
          (this.isMember || vipIndex != -1) && this.$public.isNull(arr[i].activityId) && selectdiscount.indexOf(arr[i].ce2) == -1 && arr[i].vipPrice > 0
        ) {
          arr[i].price = arr[i].vipPrice;
        }
        //  let selectdiscount = this.$store.state.mendian.selectdiscount
        //  if (selectdiscount.indexOf(arr[i].ce2)!=-1&&arr[i].num > 0) {
        //   if (arr[i].num > 0) {
        //     arr[i].num--
        //   }
        //  }
        if ((this.$public.isNull(arr[i].activityId) && this.$public.isNull(arr[i].couponId)) && arr[i].vipPrice > 0) {
          total.showVip = true
          total.viptotal = this.$public.jia(
            total.viptotal,
            this.$public.cheng(arr[i].vipPrice, arr[i].num)
          );
        } else {
          total.viptotal = this.$public.jia(
            total.viptotal,
            this.$public.cheng(arr[i].price, arr[i].num)
          );
        }

        total.activity = this.$public.jia(
          total.activity,
          this.$public.cheng(arr[i].price, arr[i].num)
        );

        total.total = this.$public.jia(
          total.total,
          this.$public.cheng(arr[i].originalPrice, arr[i].num)
        );
      }
      // 这里计算的是总的优惠券
      if (!this.$public.isNull(this.curDiscountCard)) {
        // 有优惠券
        let totalMoney = total.total;
        let state = false;
        if (this.curDiscountCard.activity_type === 1) {
          // 满减
          if (Number(totalMoney) >= this.curDiscountCard.money_top) {
            state = true;
          }
        } else if (this.curDiscountCard.activity_type === 2) {
          // 折扣
          if (Number(totalMoney) >= this.curDiscountCard.rebate_top) {
            state = true;
          }
        } else if (this.curDiscountCard.activity_type === 3) {
          // 折扣
          let state1 = false;
          for (let i = 0; i < this.tableData.length; i++) {
            let item = this.tableData[i];
            if (
              item.goodsId === this.curDiscountCard.goods_id &&
              item.skus === this.curDiscountCard.sku_id &&
              item.unitId === this.curDiscountCard.packing_way_id
            ) {
              state1 = true;
            }
          }
          state = state1;
        }
        if (state === true) {
          if (this.curDiscountCard.activity_type === 1) {
            totalMoney = this.$public.jian(
              totalMoney,
              this.curDiscountCard.money_reduce
            );
          } else if (this.curDiscountCard.activity_type === 2) {
            let yh = this.$public.cheng(
              totalMoney,
              this.$public.jian(1, this.curDiscountCard.rebate)
            );
            if (this.curDiscountCard.rebate_limit > 0) {
              if (yh > this.curDiscountCard.rebate_limit) {
                yh = this.curDiscountCard.rebate_limit;
              }
            }
            total.activity = this.$public.jian(totalMoney, yh);
          } else if (this.curDiscountCard.activity_type === 3) {
            console.log("抵扣");
          }
        } else {
          this.$message({
            message: "不满足优惠券的使用条件，优惠券已取消！！",
            type: "error",
          });
          this.$store.commit("mendian/set_curDiscountCard", null);
        }
      }
      this.$store.commit("mendian/set_saleTotal", total);
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  padding-bottom: 65px;
  box-sizing: border-box;
  height: 100%;
  position: relative;

  .titleLine {
    position: absolute;
    z-index: 1;
    width: 100%;
    background-color: #fff;
    height: 48px;
    padding: 12px 12px 12px 12px;
    box-sizing: border-box;
    font-size: 14px;
    color: $fontColor;

    .taskBox {
      display: flex;
      padding-top: 4px;

      .taskItem {
        display: flex;
        align-items: center;
        padding: 0 20px;
        border-right: 2px solid #f5f5f5;
        cursor: pointer;

        &:last-child {
          border-right: 0;
        }

        .taskNum {
          font-size: 12px;
          color: #fff;
          margin-right: 4px;
          background-color: #ff182a;
          border-radius: 50%;
          width: 20px;
          line-height: 20px;
          text-align: center;
        }

        .taskText {
          font-size: 14px;
          color: #1890ff;
          padding-right: 4px;
        }

        .taskNext {
          width: 4px;
          height: 7px;
        }
      }
    }
  }

  .tableBox {
    height: 100%;
    padding-top: 48px;
    box-sizing: border-box;
  }

  .btn_operate {
    width: 10px;
    height: 10px;
    padding-right: 5px;
    cursor: pointer;
  }
}
</style>
